var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

const React = require('react');
const Icon = require('@infotech/uikit-icon').default;

function Svg(props) {
  const svgProps = Object.assign({}, props);
  const title = props.title;
  delete props.title;

  /* <svg {...svgProps} ><title>{title}<title>...</svg> */
  return React.createElement(
    'svg',
    _extends({ width: '24', height: '24', viewBox: '0 0 24 24', focusable: 'false' }, svgProps, { 'aria-labelledby': 'title' }),
    React.createElement(
      'title',
      { id: 'title' },
      title
    ),
    React.createElement('path', { d: 'M12 20a1 1 0 000-2H4a1 1 0 000 2h8zm8-5a1 1 0 000-2H4a1 1 0 000 2h16zm0-5a1 1 0 000-2H4a1 1 0 000 2h16zm0-5a1 1 0 000-2H4a1 1 0 000 2h16z', fillRule: 'evenodd', role: 'presentation' })
  );
}

module.exports = function listView(props) {
  return React.createElement(Icon, _extends({ glyph: Svg }, props));
};